import React from 'react';
import { FileText, Image as ImageIcon, ExternalLink } from 'lucide-react';
import useInternalCoverBlob from '@/components/calendar/useInternalCoverBlob';
import { reimbursementAPI } from '@/lib/api';

// A single receipt shown as a thumbnail (images) or a file chip (PDF).
// Clicking opens the authenticated blob in a new tab.
export default function ReceiptThumb({ requestId, receipt }) {
  const relUrl = reimbursementAPI.receiptUrl(requestId, receipt.storage_key);
  const isImage = (receipt.content_type || '').startsWith('image/');
  const blobUrl = useInternalCoverBlob(isImage ? relUrl : null);

  const open = async () => {
    const token = localStorage.getItem('token');
    const backend = process.env.REACT_APP_BACKEND_URL;
    try {
      const res = await fetch(`${backend}${relUrl}`, { headers: token ? { Authorization: `Bearer ${token}` } : {} });
      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      window.open(url, '_blank', 'noopener');
    } catch {
      /* ignore */
    }
  };

  return (
    <button
      type="button"
      onClick={open}
      className="group relative flex items-center gap-2 rounded-lg border border-slate-200 bg-white p-2 hover:border-slate-300 hover:shadow-sm transition text-left"
      data-testid={`receipt-thumb-${receipt.storage_key}`}
      title={receipt.filename}
    >
      {isImage && blobUrl ? (
        <img src={blobUrl} alt={receipt.filename} className="h-12 w-12 rounded object-cover" />
      ) : (
        <span className={`flex h-12 w-12 items-center justify-center rounded ${isImage ? 'bg-slate-100 text-slate-400' : 'bg-rose-50 text-rose-500'}`}>
          {isImage ? <ImageIcon size={18} /> : <FileText size={18} />}
        </span>
      )}
      <span className="min-w-0 max-w-[140px]">
        <span className="block truncate text-xs font-medium text-slate-700">{receipt.filename}</span>
        <span className="text-[11px] text-slate-400 flex items-center gap-1"><ExternalLink size={10} /> Open</span>
      </span>
    </button>
  );
}
